// @flow

/**
 * Module dependencies.
 */

import { colors, defaultTransition, states } from 'client/styles';
import { compose } from 'recompose';
import { map } from 'lodash/fp';
import { position, size } from 'polished';
import { pushRoute } from 'client/core/utils';
import { translator } from 'core/utils';
import { withRouter } from 'react-router';
import Icon from 'client/components/core/icon';
import React, { Component } from 'react';
import entities from 'client/core/entities';
import i18n from 'client/translations/i18n';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  fixed: boolean,
  location: Object,
  router: Object,
  translate: Function
};

/**
 * Type `Option`.
 */

type Option = {
  label: string,
  value: string
};

/**
 * Styles.
 */

const styles: Object = {
  caret: `
    left: auto;
    right: 0;
  `,
  icon: `
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  `
};

/**
 * `Wrapper` component.
 */

const Wrapper = styled.span`
  ${size('25px', '75px')};

  color: ${({ color }): string => color};
  display: block;
  float: left;
  position: relative;
  transition: color ${defaultTransition};
`;

/**
 * `SelectStyle` component.
 */

const SelectStyle = styled.select`
  ${position('absolute', '0', '0', '0', '0')};

  appearance: none;
  background-color: transparent;
  text-indent: 28px;
  text-transform: uppercase;
  width: 100%;

  ${states.action`
    border: 0;
    outline: none;
  `}
`;

/**
 * `Languages` component.
 */

class Languages extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Handle change language.
   */

  handleChangeLanguage(event: Object, location: Object) {
    i18n.changeLanguage(event.target.value);

    pushRoute(i18n.language, location.pathname);
  }

  /**
   * Render options.
   */

  renderOptions = map((option: Option) => (
    <option
      key={option.value}
      value={option.value}
    >
      {option.label}
    </option>
  ));

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { fixed, location, translate } = this.props;
    const { languages } = entities(translate);

    return (
      <Wrapper color={fixed ? colors.rollingStone : colors.white}>
        <Icon
          color={colors.brandPrimary}
          icon={'language'}
          styles={styles.icon}
        />

        <SelectStyle
          onChange={event => this.handleChangeLanguage(event, location)}
          value={i18n.language}
        >
          {this.renderOptions(languages)}
        </SelectStyle>

        <Icon
          icon={'caret'}
          styles={[styles.icon, styles.caret]}
        />
      </Wrapper>
    );
  }

}

/**
 * Export `Languages`.
 */

export default compose(
  translator(),
  withRouter
)(Languages);



// WEBPACK FOOTER //
// ../src/client/components/core/languages/index.js